import { motion } from "framer-motion";
import { Zap } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { DELIVERY_INCLUDES } from "@/data/content";

export const DeliveryPromise = () => {
  return (
    <section
      className="py-14 sm:py-16 bg-card/40 border-y border-border"
      data-testid="delivery-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="card-highlight rounded-3xl bg-card border border-border p-7 sm:p-10 relative overflow-hidden">
            <div
              aria-hidden="true"
              className="absolute inset-0 pointer-events-none"
              style={{
                background:
                  "radial-gradient(700px circle at 12% 0%, rgba(214,179,106,0.08), transparent 55%)",
              }}
            />
            <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-4">
                <div className="flex items-center gap-2 mb-3">
                  <Zap className="w-4 h-4 text-primary" />
                  <span className="text-xs uppercase tracking-widest text-primary font-medium">
                    All-Inclusive · Fast Delivery
                  </span>
                </div>
                <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-foreground">
                  Live in{" "}
                  <span className="font-editorial italic text-primary">7 days</span> — everything
                  in one price
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                  Websites and mobile apps ready for the public in one week maximum. And the
                  price you're quoted is the price you pay — nothing sold separately.
                </p>
              </div>

              <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
                {DELIVERY_INCLUDES.map((item, i) => {
                  const Icon = item.icon;
                  return (
                    <motion.div
                      key={item.label}
                      initial={{ opacity: 0, y: 16 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true, margin: "-40px" }}
                      transition={{ duration: 0.5, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                      className="rounded-2xl bg-secondary/50 border border-border p-4 text-center hover:border-primary/35 transition-colors duration-300"
                      data-testid="delivery-include-card"
                    >
                      <div className="w-10 h-10 mx-auto rounded-xl bg-primary/10 border border-primary/25 grid place-items-center mb-3">
                        <Icon className="w-4.5 h-4.5 text-primary" size={18} />
                      </div>
                      <p className="text-xs font-semibold text-foreground">{item.label}</p>
                      <p className="text-[10px] text-muted-foreground mt-1">{item.note}</p>
                    </motion.div>
                  );
                })}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
